import styled from "styled-components";
import { pxToRem, withAlpha } from "../../styles/utils";

export const LessonDetailsContainer = styled.div`
  width: 100%;
  min-width: 0;
  padding: ${({ theme }) => pxToRem(theme.spacing.lg)};
  border-bottom: ${pxToRem(1)} solid ${({ theme }) => theme.borders.divider};
  background: ${({ theme }) => withAlpha(theme.colors.brand, 0.02)};
  white-space: normal;
`;

export const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(${pxToRem(280)}, ${pxToRem(360)});
  gap: ${({ theme }) => pxToRem(theme.spacing.lg)};
  align-items: start;

  @media (max-width: 940px) {
    grid-template-columns: 1fr;
  }
`;

export const ReadBlock = styled.div`
  margin-bottom: ${({ theme }) => pxToRem(theme.spacing.md)};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ReadLabel = styled.div`
  margin-bottom: ${({ theme }) => pxToRem(theme.spacing.xxs)};
  color: ${({ theme }) => withAlpha(theme.colors.ink, 0.42)};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  font-weight: 400;
  line-height: 1.45;
`;

export const ReadText = styled.div`
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.md)};
  font-weight: 400;
  line-height: 1.55;
  white-space: pre-wrap;
`;

export const EmptyValue = styled.div`
  color: ${({ theme }) => withAlpha(theme.colors.ink, 0.3)};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.md)};
  font-weight: 400;
  line-height: 1.5;
`;

export const MaterialLink = styled.a`
  color: ${({ theme }) => theme.colors.brand};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.md)};
  font-weight: 400;
  line-height: 1.55;
  text-decoration: none;
  word-break: break-all;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(2)};
  }
`;

export const MaterialsColumn = styled.div`
  min-width: 0;
`;

export const SectionTitle = styled.h3`
  margin: 0 0 ${({ theme }) => pxToRem(theme.spacing.xs)};
  color: ${({ theme }) => withAlpha(theme.colors.ink, 0.5)};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.md)};
  font-weight: 600;
  line-height: 1.45;
`;

export const FilesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => pxToRem(theme.spacing.xs)};
  margin-top: ${({ theme }) => pxToRem(theme.spacing.xs)};
`;

export const FileRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => pxToRem(theme.spacing.xs)};
  min-width: 0;
  padding: ${({ theme }) => pxToRem(theme.spacing.xs)} ${({ theme }) => pxToRem(theme.spacing.sm)};
  border: ${pxToRem(1)} solid ${({ theme }) => theme.borders.outline};
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.ink};
`;

export const FileIconBox = styled.span`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: ${pxToRem(30)};
  height: ${pxToRem(30)};
  border-radius: ${({ theme }) => pxToRem(theme.radii.sm)};
  background: ${({ theme }) => theme.colors.inkSurface};
  color: ${({ theme }) => theme.colors.brand};

  svg {
    width: ${pxToRem(15)};
    height: ${pxToRem(19)};
  }
`;

export const FileMain = styled.span`
  display: block;
  min-width: 0;
  flex: 1 1 auto;
`;

export const FileName = styled.span`
  display: block;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.md)};
  font-weight: 400;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FileMeta = styled.span`
  display: block;
  color: ${({ theme }) => withAlpha(theme.colors.ink, 0.42)};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  font-weight: 400;
  line-height: 1.35;
`;

export const ProgressTrack = styled.span`
  display: block;
  height: ${pxToRem(4)};
  margin-top: ${({ theme }) => pxToRem(theme.spacing.xxs)};
  overflow: hidden;
  border-radius: ${({ theme }) => pxToRem(theme.radii.pill)};
  background: ${({ theme }) => theme.borders.divider};
`;

export const ProgressBar = styled.span<{ $progress: number }>`
  display: block;
  width: ${({ $progress }) => `${Math.max(0, Math.min(100, $progress))}%`};
  height: 100%;
  border-radius: inherit;
  background: ${({ theme }) => theme.colors.brand};
`;

export const VideoPlayersContainer = styled.div`
  width: 100%;
  margin-top: ${({ theme }) => pxToRem(theme.spacing.xs)};

  > div {
    width: 100% !important;
    min-height: 0 !important;
    height: auto !important;
    aspect-ratio: 16 / 9;
    overflow: hidden;
    border: ${pxToRem(1)} solid ${({ theme }) => theme.borders.outline};
    border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
    background: ${({ theme }) => theme.colors.black};
  }

  > div > div {
    min-height: 0 !important;
    height: 100% !important;
  }

  video {
    min-height: 0 !important;
    height: 100% !important;
  }
`;
